import React from 'react';
import { useSelector } from 'react-redux';

import BrowseSimilarCategories from '../components/BrowseSimilarCategories';
import FullWidthSimilarStockItems from '../components/FullWidthSimilarStockItems';
import RelatedKeywords from '../components/RelatedKeywords';
import { selectDetailsStockItem } from '../selectors/detailsSelectors';
import StockItemInformationContainer from './GraphicStockItemInformationContainer';

import './stock-item-details.less';

const GraphicDetailsContainer = () => {
  const stockItem = useSelector(selectDetailsStockItem);

  return (
    <div className="w-full overflow-hidden">
      <div className="stockItemDetails w-full max-w-8xl mb-16">
        <div className="px-6">
          <StockItemInformationContainer />
          <div className="stockItemDetails-similarClipsRow">
            <div className="stockItemDetails-section">
              <FullWidthSimilarStockItems
                contentType={stockItem.contentType}
                contentClass={stockItem.contentClass}
                detailsUrl={stockItem.detailsUrl}
                headerClassName={'text-2xl mt-11 md:-mb-8 ml-4'}
              />
            </div>
          </div>
          <RelatedKeywords
            keywords={stockItem.keywords}
            title="Related Stock Image Keywords"
          />
          <BrowseSimilarCategories
            categories={stockItem.categories}
            contentType={stockItem.contentType}
          />
        </div>
      </div>
    </div>
  );
};

export default GraphicDetailsContainer;
